export * from "./star-icon.component";
